import { toast } from 'react-toastify';
import { ProductItemProps } from '../models/Product';
import { Resources } from '../models/ScheduleResource';
import { ServiceItemProps } from '../models/Service';
import { BusnessRule, catalogoApi, lambdaValidateApi } from '../services/api';
import { ResponseAPI } from './responseApi';
import { AxiosError } from 'axios';
import { SystemUnavailableError } from '../errors';

export const fetchProducts = async (filter: string) => {
  const response = await catalogoApi.get('products', {
    params: { product: filter }
  });

  const { data } = response;
  return data;
};

export const fetchProductById = async (productId: string) => {
  const result: ResponseAPI<ProductItemProps> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as ProductItemProps
  };
  try {
    const response = await catalogoApi.get(`products/${productId}`);
    // result.data = productMock;
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    toast.error('Erro ao obter produto');
    return result;
  }
};

export const fetchServiceById = async (serviceId: string) => {
  const result: ResponseAPI<ServiceItemProps> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as ServiceItemProps
  };
  try {
    const response = await lambdaValidateApi.get('validate-products/', {
      params: {
        serviceId
      }
    });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    toast.error('Erro ao obter serviço');
    return result;
  }
};

export const fetchActiveServices = async (name = '') => {
  const result: ResponseAPI<Resources[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Resources[]
  };
  let params = {};
  if (name) params = { name };
  try {
    const response = await lambdaValidateApi.get('validate', {
      params
    });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchExternalClientServices = async (name = '') => {
  const result: ResponseAPI<Resources[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Resources[]
  };
  let params = {};
  if (name) params = { name };
  try {
    const response = await BusnessRule.get('/product-validator/client/services', {
      params
    });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchCatalogService = async (serviceId?: string) => {
  const result: ResponseAPI<any> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as any
  };
  try {
    const response = await catalogoApi.get(`/services/${serviceId}?auto_scheduling_only=1`);
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    toast.error('Erro ao obter serviço');
    return result;
  }
};

export const validateApsEligibility = async (params: { document: string; documentType: string }) => {
  try {
    const response = await lambdaValidateApi.post('validate-web-aps', params);
    return response.data;
  } catch (e) {
    const error = e as AxiosError;

    throw new SystemUnavailableError(error.message);
  }
};
